/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProgramPeriod } from '../../models/program-period';

export interface UpdateAdminProgramPeriod$Params {
  id: string;
  body: ProgramPeriod;
}

export function updateAdminProgramPeriod(
  http: HttpClient,
  rootUrl: string,
  params: UpdateAdminProgramPeriod$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<ProgramPeriod>> {
  const rb = new RequestBuilder(rootUrl, updateAdminProgramPeriod.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProgramPeriod>;
    })
  );
}

updateAdminProgramPeriod.PATH = '/admin/program-periods/{id}';
